export const PREBID_VERSION = "1.23.0";
export const REFRESH_AD_COOLDOWN_SECONDS = 60;
export const AD_VISIBILITY_LEEWAY = 150;

export const AMAZON_PUB_ID = "3121";

export const BIDDERS = {
	prebid: "prebid",
	amazon: "amazon",
	timeout: "timeout",
};

export const NETWORKS = {
	appnexus: "appnexus",
	indexExchange: "indexExchange",
	aol: "aol",
};

export const FORMATS_KEYS = {
	LEADER: "leader",
	LEADER_EXPANDED: "leader_expanded",
	LEADER_ADDL: "leader_addl",
	BOX: "box",
	BOX_ADDL: "box_addl",
	SKY: "sky",
	SKY_R: "sky_r",
	HALF_PAGE: "half_page",
	LEADER_BILLBOARD: "leader_billboard",
	LOGOUT: "logout",
	MOBILE: "mobile",
	MOBILE_BOX: "mobile_box",
};

export const FORMATS = {
	[FORMATS_KEYS.LEADER]: [[728, 90]],
	[FORMATS_KEYS.LEADER_EXPANDED]: [[728, 90], [970, 250], [970, 90]],
	[FORMATS_KEYS.LEADER_ADDL]: [[728, 90]],
	[FORMATS_KEYS.BOX]: [[300, 250]],
	[FORMATS_KEYS.BOX_ADDL]: [[300, 250]],
	[FORMATS_KEYS.SKY]: [[160, 600]],
	[FORMATS_KEYS.SKY_R]: [[160, 600]],
	[FORMATS_KEYS.HALF_PAGE]: [[300, 600], [300, 250]],
	[FORMATS_KEYS.LEADER_BILLBOARD]: [[970, 250]],
	[FORMATS_KEYS.LOGOUT]: [[800, 600]],
	[FORMATS_KEYS.MOBILE]: [[300, 50], [320, 50]],
	[FORMATS_KEYS.MOBILE_BOX]: [[300, 250]],
};

export const FORMATS_AOL = {
	leader: 225,
	leader_addl: 225,
	box: 170,
	box_addl: 170,
	sky: 154,
	half_page: 529,
	mobile: 3055,
	mobile_box: 170,
};

export const FORMATS_INDEX_EXCHANGE = {
	leader: 1,
	sky: 11,
	sky_r: 21,
	box: 31,
	leader_addl: 41,
	box_addl: 51,
	half_page: 61,
	mobile: 71,
	mobile_box: 81,
};

export const PLACEMENTS_SOVRN = {
	leader: 409715,
	box: 409708,
	leader_addl: 409715,
	box_addl: 409708,
	half_page: 409712,
	mobile: 409718,
	mobile_box: 409711,
};

export const PLACEMENTS_OPENX = {
	CA: {
		box: 538944180,
		half_page: 538944167,
		leader: 538943378,
		leader_expanded: 538944147,
		logout: 538944173,
		mobile_box: 538944148,
		mobile: 538943355,
	},
	UK: {
		box: 538943960,
		half_page: 538944174,
		leader: 538944149,
		leader_expanded: 538943369,
		logout: 538943981,
		mobile_box: 538944176,
		mobile: 538944169,
	},
	US: {
		box: 538943371,
		half_page: 538944146,
		leader: 538944175,
		leader_expanded: 538944163,
		logout: 538943370,
		mobile_box: 538944139,
		mobile: 538944298,
	},
	OTHER: {
		box: 538944289,
		half_page: 538944221,
		leader: 538944286,
		leader_expanded: 538944299,
		logout: 538944290,
		mobile_box: 538944222,
		mobile: 538944287,
	},
};

export const PLACEMENTS_CRITEO = {
	sky: 815036,
	box: 815037,
	mobile_box: 815037,
	half_page: 815038,
	leader: 815039,
	mobile: 815040,
	leader_extended: 815041,
	logout: 815044,
};

export const PLACEMENTS_APPNEXUS = {
	home: {
		leader: 6978481,
		box: 7050421,
		box_addl: 7050423,
	},
	profile: {
		leader: 6978481,
	},
	matchsearch: {
		leader: 7050426,
		leader_addl: 7050436,
	},
	messages: {
		leader: 7050437,
		half_page: 7050438,
	},
	quickmatch: {
		leader: 7473576,
		box: 7473577,
		box_addl: 7473577,
	},
	visitors: {
		leader: 7473579,
		box: 7473580,
	},
	visited: {
		leader: 7473581,
		half_page: 7473583,
	},
	whoyoulike: {
		leader: 7473589,
		half_page: 7473590,
	},
	mutuallikes: {
		leader: 7473591,
		half_page: 7473592,
	},
	logout: 7473594,
	mobile: 7050443,
	mobile_box: 7611547,
};

export const PLACEMENTS_AOL = {
	home: {
		box: 4203032,
		box_addl: 4203035,
		leader: 4203028,
	},
	messages: {
		leader: 4203027,
		half_page: 4203037,
	},
	mutuallikes: {
		half_page: 4203046,
		leader: 4203041,
	},
	profile: {
		leader: 4203039,

	},
	quickmatch: {
		box: 4203038,
		box_addl: 4203038,
		leader: 4203043,
	},
	matchsearch: {
		leader: 4203040,
		leader_addl: 4203045,
	},
	visited: {
		half_page: 4203044,
		leader: 4203042,
	},
	visitors: {
		box: 4203048,
		leader: 4203049,
	},
	whoyoulike: {
		half_page: 4203050,
		leader: 4203047,
	},
	mobile_box: 4203060,
	mobile: 4203061,
	logout: 4203033,
};

export const PLACEMENTS_INDEX_EXCHANGE = {
	leader: 181478,
	sky: 183879,
	sky_r: 183880,
	box: 183881,
	leader_addl: 183882,
	box_addl: 183883,
	half_page: 183884,
	mobile: 183885,
	mobile_box: 183886,
};

export const PAGEMAP = {
	"Home": "home",
	"Profile": "profile",
	"Profile-Questions": "profile",
	"Profile-Photos": "profile",
	"Profile-Tests": "profile",
	"Match": "matchsearch",
	"Mailbox": "messages",
	"Logout": "logout",
	"Quick": "quickmatch",
	"Visitors": "visitors",
	"Visited": "visited",
	"Who-I-Rated": "whoyoulike",
	"Mutual-Likes": "mutuallikes",
};



// WEBPACK FOOTER //
// ./src/shared/modules/onpageads/constants.js